import bitmapTemplate from '../../templates/bitmap.hbs';
import {apiClient, getCookie} from "./api";
import { initializeFlagHandlers } from './flags';
import { initializeVoteHandlers } from './voting';
import $ from "jquery";

let currentPage = 1; // Keeps track of the current page number (starting at 1)
let isFetching = false; // Prevents multiple simultaneous API calls
let hasMore = true; // Flag to check if there are more results to load
let isScrollable = false; // Tracks if scrolling is enabled
let currentVisibility = 'public'; // Default visibility
let isInitialLoad = true; // Prevent observer from triggering on initial page load

export async function showBitmap(bitmapId) {
    if (!bitmapId) {
        return;
    }

    // Render full-size bitmap based on the bitmap id
    let bitmap = bitmapData[bitmapId];
    if (bitmap) {
        bitmap.nickname = bitmap.creator.nickname || bitmap.creator.username || 'Anonymous';
        var bitmapHtml = bitmapTemplate(bitmap);
        $('#fullsize-bitmap').append(bitmapHtml);
    } else {
        $('#fullsize-bitmap').html("<p>Bitmap not found.</p>");
    }
}

function toggleLoadingIndicator(show) {
    const loadingElement = document.querySelector('.loading');
    loadingElement.style.display = show ? 'block' : 'none';
}

async function loadMoreBitmaps() {
    if (isFetching || !hasMore)  {
        return;
    }
    isFetching = true;
    toggleLoadingIndicator(true); // Show the loading indicator

    // Fetch the next page of bitmaps
    // We don't need to increment here as fetchBitmaps handles incrementing
    await fetchBitmaps(currentPage, currentVisibility);
}

// Function to fetch bitmaps from the API
export async function fetchBitmaps(pageNumber, visibility='public') {
    let perPage = 8;
    let apiUrl = '/api/bitmaps/';
    currentVisibility = visibility;
    if (visibility === 'private') {
        apiUrl = apiUrl + 'private/';
    }

    // Only set the current page on first call or explicit reset
    if (pageNumber === 1) {
        currentPage = 1;
    }

    // Calculate offset from the current page
    let offset = (currentPage - 1) * perPage;

    await apiClient(apiUrl+'?limit='+perPage+'&offset=' + offset, {
            method: 'GET'
        },
        async (bitmaps) => {
            var bitmapResults = bitmaps["results"];

            // Check if user is authenticated
            const isAuthenticated = !!getCookie('access_token');
            const currentUserId = getCookie('id') ? parseInt(getCookie('id')) : null;
            
            // Render the bitmaps using Handlebars
            bitmapResults.forEach(function (bitmap) {
                let creator = bitmap.creator.nickname || bitmap.creator.username || 'Anonymous';
                let bitmap_name = bitmap.caption || '--untitled--';
                let user_slug = bitmap.creator.slug;
                bitmap["nickname"] = creator;
                bitmap["user_slug"] = user_slug;
                bitmap["title"] = bitmap_name;
                
                // Check if this is the user's own bitmap
                const isOwnBitmap = currentUserId && bitmap.creator.id === currentUserId;
                
                // Create context with authentication status and ownership info
                const context = {
                    ...bitmap,
                    isAuthenticated: isAuthenticated,
                    isOwnBitmap: isOwnBitmap
                };
                
                let bitmapHtml = bitmapTemplate(context);
                $('#gallery').append(bitmapHtml);
                // Store bitmap data for later reference
                if (!window.bitmapData) {
                    window.bitmapData = {};
                }
                window.bitmapData[bitmap["id"]] = bitmap;
            });

            // Check if there are more pages
            if (!bitmaps.next) {
                hasMore = false; // No more data to load
            }

            // Increment the current page for the next load
            currentPage++;

            isFetching = false;
            toggleLoadingIndicator(false); // Hide the loading indicator

            // Initialize flag handlers for the newly loaded bitmaps
            initializeFlagHandlers();
            
            // Initialize vote handlers for the newly loaded bitmaps
            initializeVoteHandlers();
            
            // Mark initial load as complete
            isInitialLoad = false;
            
            // Check if content is scrollable; if not, load more
            await checkIfScrollable(visibility);
        },
        (error) => {
            console.error('Error fetching bitmaps:', error);
            $('#gallery').html("<p>Error loading bitmaps.</p>");
            isFetching = false; // Allow retries
            toggleLoadingIndicator(false); // Hide the loading indicator

            // Handle non-auth-related errors here
        });
}

// Function to check if the content is scrollable
async function checkIfScrollable(visibility) {
    const gallery = document.querySelector('#gallery');
    const sentinel = document.querySelector('#scroll-sentinel');
    const viewportHeight = window.innerHeight;

    if (gallery.offsetHeight + sentinel.offsetHeight < viewportHeight && hasMore) {
        await loadMoreBitmaps();
    } else {
        isScrollable = true;
    }
}


// Use IntersectionObserver to trigger loading when the sentinel is visible
const observer = new IntersectionObserver(async (entries) => {
    for (const entry of entries) {
        if (entry.isIntersecting && hasMore && !isInitialLoad) {
            await loadMoreBitmaps();
        }
    }
}, {
    rootMargin: '200px' // Trigger before the sentinel is fully visible
});

// Start observing the sentinel element
const sentinel = document.querySelector('#scroll-sentinel');
observer.observe(sentinel);
